import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import InputGroup from 'react-bootstrap/InputGroup';
import {useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FixedButton from '../FixedButton';
import { lrAPI } from '../../redux/actionCreation';
import { fatchLRAPI } from '../../redux/actionCreation';
import MobileNavigation from '../MobileNavigation';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../Loader';
import Select from "react-select";
import { Country, State, City } from "country-state-city";

function CretaeLR() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sidebarState = useSelector(state => state.sidebarReducres);
//   const error = useSelector(state => state.lrReducers?.errors);
    const error = useSelector(
        state => state.lrReducers?.error?.errors
    );

  useEffect(() => {
    if (!localStorage.getItem("tokan")) {
      navigate("/login");
    }
  }, []);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [loading, setLoading] = useState(false);

  /* ===================== FORM STATE ===================== */
  const [formData, setFormData] = useState({
    lr_date: today,
    lr_num: "",
    risk_type: "AT OWNER'S RISK",
    truck_number: "",

    driver_name: "",
    driver_phone: "",
    driver_licence: "",

    consignor_name: "",
    consignor_phone: "",
    consignor_gst: "",
    consignor_state: "",
    consignor_city: "",
    consignor_add: "",

    consignee_name: "",
    consignee_phone: "",
    consignee_gst: "",
    consignee_state: "",
    consignee_city: "",
    consignee_add: "",

    no_package: "",
    ac_weight: "",
    ac_weight_type: "KG",
    char_weight: "",
    charg_weight_type: "KG",
    pack_condition: "ALL ITEMS IN GOOD CONDITION",
    pack_desc: "",
    remark: "",

    f_to_bill: "",
    f_paid: "",
    f_to_pay: "",
    total_basic_f: "",

    loading_charge: "",
    unloading_charge: "",
    st_charge: "",
    other_charge: "",
    lrcn_charge: "",

    gst_per: "18",
    gst_paid_by: "Exempted",

    material_Insu: "Insured",
    insu_company: "",
    policy_num: "",
    insu_date: today,
    insu_amount: "",
    insu_risk: "",

    demurrage_charge: "500",
    demurrage_type: "Per Day",
    demurrage_time: "More Than 5 Day",
  });

  useEffect(() => {
  const setAutoLRNumber = async () => {
    const res = await dispatch(fatchLRAPI());

    const lrList = res?.payload;

    if (Array.isArray(lrList) && lrList.length > 0) {
      const maxLR = Math.max(
        ...lrList.map(item => Number(item.lr_number) || 0)
      );

      setFormData(prev => ({
        ...prev,
        lr_num: maxLR + 1
      }));
    } else {
      // first LR
      setFormData(prev => ({
        ...prev,
        lr_num: 1
      }));
    }
  };

  setAutoLRNumber();
}, [dispatch]);


  /* ===================== COMMON CHANGE ===================== */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

const [selectedState, setSelectedState] = useState(null);
const [selectedCity, setSelectedCity] = useState(null);
  
  const [selectedToState, setSelectedToState] = useState(null);
  const [selectedToCity, setSelectedToCity] = useState(null);
  /* ===================== DATE ===================== */
  const handleDateChange = (name, date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    setFormData(prev => ({
      ...prev,
      [name]: d
    }));
  };

  const handleNumberChange = (e) => {
  const { name, value } = e.target;

  // empty allow
  if (value === '') {
    setFormData({ ...formData, [name]: '' });
    return;
  }

  // minus ya negative block
  if (Number(value) < 0) return;

  setFormData({ ...formData, [name]: value });
};

const handleLRNumberChange = (e) => {
  const { name, value } = e.target;

  // empty allow (backspace)
  if (value === '') {
    setFormData(prev => ({ ...prev, [name]: '' }));
    return;
  }

  // only numbers > 0
  const num = Number(value);

  if (!Number.isInteger(num) || num <= 0) return;

  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const blockInvalidKeys = (e) => {
  if (e.key === '-' || e.key === 'e' || e.key === '+') {
    e.preventDefault();
  }
};


const blockInvalidLRKeys = (e) => {
  if (
    e.key === '-' ||
    e.key === '+' ||
    e.key === 'e' ||
    e.key === 'E' ||
    e.key === '.'
  ) {
    e.preventDefault();
  }
};

  // Handle "From" State Change
const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption); // Pura object store hoga (with isoCode)
    setSelectedCity(null); 
    setFormData((prevData) => ({
        ...prevData,
        consignor_state: selectedOption ? selectedOption.value : "", // Full Name
        consignor_city: '', 
    }));
};

// Handle "To" State Change
const handleToStateChange = (selectedOption) => {
    setSelectedToState(selectedOption); // Isme ab isoCode mil jayega
    setSelectedToCity(null);
    setFormData((prevData) => ({
        ...prevData,
        consignee_state: selectedOption ? selectedOption.value : "", // Full Name
        consignee_city: '',
    }));
};

// Handle "To" City Change
const handleToCityChange = (selectedOption) => {
    setSelectedToCity(selectedOption);
    setFormData((prevData) => ({
        ...prevData,
        consignee_city: selectedOption ? selectedOption.value : "",
    }));
};


// Handle "From" City Change
const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    setFormData((prevData) => ({
        ...prevData,
        consignor_city: selectedOption ? selectedOption.value : "",
    }));
};


  const handleLRDateChange = (date) => {
    const modifiedDate = new Date(date);
    modifiedDate.setHours(0, 0, 0, 0);
    // Format the date to "dd-mm-yyyy"
    const day = String(modifiedDate.getDate()).padStart(2, '0');
    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(modifiedDate.getFullYear());

    const formattedDate = `${day}-${month}-${year}`;
    console.log("date", formattedDate);
    // Update the recipts_date field in formData when the DatePicker changes
    setFormData((prevState) => ({
        ...prevState,
        lr_date: modifiedDate
    }));
};

 const handleLRInsuDateChange = (date) => {
    const modifiedDate = new Date(date);
    modifiedDate.setHours(0, 0, 0, 0);
    // Format the date to "dd-mm-yyyy"
    const day = String(modifiedDate.getDate()).padStart(2, '0');
    const month = String(modifiedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = String(modifiedDate.getFullYear());

    const formattedDate = `${day}-${month}-${year}`;
    console.log("date", formattedDate);
    // Update the recipts_date field in formData when the DatePicker changes
    setFormData((prevState) => ({
        ...prevState,
        insu_date:modifiedDate
    }));
};

  /* ===================== TOTAL CALC ===================== */
  const num = (v) => parseFloat(v) || 0;

  const calculateTotal = () => {
    return (
      num(formData.f_to_bill) +
      num(formData.loading_charge) +
      num(formData.unloading_charge) +
      num(formData.st_charge) +
      num(formData.other_charge) +
      num(formData.lrcn_charge)
    );
  };

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      total_charge: calculateTotal()
    }));
  }, [
    formData.f_to_bill,
    formData.loading_charge,
    formData.unloading_charge,
    formData.st_charge,
    formData.other_charge,
    formData.lrcn_charge,
  ]);

// const [fromState, setFromState] = useState(null);
// const [toState, setToState] = useState(null);

  /* ===================== STATE / CITY ===================== */
// Get Indian states
const states = State.getStatesOfCountry("IN").map((state) => ({
    value: state.name,     // Database mein "Gujarat" jayega
    label: state.name,     // Dropdown mein "Gujarat" dikhega
    isoCode: state.isoCode // City load karne ke liye internal use (GJ)
}));

// "From" cities filter logic
const cities = selectedState 
    ? City.getCitiesOfState("IN", selectedState.isoCode).map((city) => ({
        value: city.name,
        label: city.name,
    }))
    : [];

// "To" cities filter logic
const toCities = selectedToState 
    ? City.getCitiesOfState("IN", selectedToState.isoCode).map((city) => ({
        value: city.name,
        label: city.name,
    }))
    : [];

  /* ===================== SUBMIT ===================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const finalData = {
      ...formData,

      // EMPTY → 0 FIX
      f_to_bill: num(formData.f_to_bill),
      f_paid: num(formData.f_paid),
      f_to_pay: num(formData.f_to_pay),
      total_basic_f: num(formData.total_basic_f),

      loading_charge: num(formData.loading_charge),
      unloading_charge: num(formData.unloading_charge),
      st_charge: num(formData.st_charge),
      other_charge: num(formData.other_charge),
      lrcn_charge: num(formData.lrcn_charge),

      insu_amount: num(formData.insu_amount),
      demurrage_charge: num(formData.demurrage_charge),

      total_charge: calculateTotal(),
    };

    try {
      const res = await dispatch(lrAPI(finalData));
      setLoading(false);

      if (res?.type === "ADD_DATA_SUCCESS") {
        navigate("/createlr");
      } else {
        Swal.fire("Error", "Please check required fields", "error");
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  return (
    <>
        {/* <FixedButton/> */}
        <div className={`main-content ${!sidebarState ? '' : 'navbar-ful'}`}>
            <div className='page-content'>
                <Container fluid>
                    <Row>
                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className='mb-2'>
                            <h5>Create LR</h5>
                        </Col>
                    </Row>
                        <Card className='quotaion-create'>
                            <Card.Body className='p-3'>
                                <Form onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                        <h6 className='mb-0 bg-gray p-2'>LR-Lorry Receipt Details (बिल्टी की जानकारी)</h6>
                                            <hr className='w-10'/>
                                        </Col>

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>Lr Number (बिल्टी नंबर)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                min={1}
                                                placeholder="Lr Number.."
                                                name="lr_num"
                                                value={formData.lr_num}
                                                onChange={handleLRNumberChange}
                                                onKeyDown={blockInvalidLRKeys }
                                                />

   
                                            {error?.lr_num && (
                                                <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                    {error.lr_num}
                                                </span>
                                            )}
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridPassword" className='mt-3'>
                                        <Form.Label>LR Date (LR की तारीख)</Form.Label>
                                            <div className="date-picker-container">
                                                <i className='calendar-icon fa fa-calendar'></i>
                                                <DatePicker
                                                    selected={formData.lr_date}
                                                    onChange={handleLRDateChange}
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="LR Date"
                                                    className='form-control'
                                                    required
                                                />
                                            </div>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>Risk Type (किसका रिस्क है?) <span class="text-danger">*</span></Form.Label> 
                                            {/* <Form.Control type="text" placeholder="Service Name.." onChange={handleChange} name="risk_type" value={formData.risk_type} required/> */}

                                            <select className='form-select' onChange={handleChange} name="risk_type" value={formData.risk_type}>
                                                    <option value="AT OWNER'S RISK">AT OWNER'S RISK</option>
                                                    <option value="AT CARRIER'S RISK">AT CARRIER'S RISK</option>
                                            </select>
                                        </Form.Group>
                                        
                                        <Form.Group as={Col} xs="12" sm="12" md="3" lg="3" xl="3" xxl="3" controlId="formGridPassword" className='mt-3'>
                                            <Form.Label>Truck/Vehicle No. (गाड़ी नंबर) <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Truck/Vehicle No.." name="truck_number" value={formData.truck_number}/>
                                        </Form.Group>
                                        
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                        <h6 className='mb-0 bg-gray p-2 mt-3'>Driver Information (ड्राइवर की जानकारी)</h6>
                                            <hr className='w-10'/>
                                        </Col>

                                         <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Driver Name <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Driver Name.." name="driver_name" value={formData.driver_name}/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Driver's Mobile No. <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Driver's Mobile No.." name="driver_phone" value={formData.driver_phone} onInput={(e) => {
                                                if (e.target.value.length > 10) {
                                                    e.target.value = e.target.value.slice(0, 10);
                                                }
                                            }}/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Driver's Licence No. <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Driver's Licence No.." name="driver_licence" value={formData.driver_licence}/>
                                        </Form.Group>

                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                        <h6 className='mb-0 mt-3 bg-gray p-2'>Consignor/Move From (जहां से सामान जाएगा):</h6>
                                            <hr className='w-10'/>
                                        </Col>

                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Consignor Name (भेजने वाले का नाम) <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Consignor Name.." name="consignor_name" value={formData.consignor_name} required/>

                                             {error?.consignor_name && (
                                                <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                    {error.consignor_name}
                                                </span>
                                            )}
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Consignor Phone (भेजने वाले का फोन) <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Consignor Phone.." name="consignor_phone" value={formData.consignor_phone} onInput={(e) => {
                                                if (e.target.value.length > 10) {
                                                    e.target.value = e.target.value.slice(0, 10);
                                                }
                                            }}/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>GSTIN (भेजने वाले का जीएसटी नंबर) <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Consignor GSTIN.." name="consignor_gst" value={formData.consignor_gst}/>
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" className="mt-3">
                                            <Form.Label><b>From</b> State (भेजने वाले का राज्य)</Form.Label>
                                            <Select
                                                options={states} // Sahi: States ki list dikhegi
                                                value={selectedState} 
                                                onChange={handleStateChange}
                                                placeholder="Select State"
                                            />
                                        </Form.Group>

                                        {/* FROM CITY */}
                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" className="mt-3">
                                            <Form.Label><b>From</b> City (भेजने वाले का शहर)</Form.Label>
                                            <Select
                                                options={cities} // Sahi: Filtered cities dikhengi
                                                value={selectedCity}
                                                onChange={handleCityChange}
                                                placeholder="Select City"
                                            />
                                        </Form.Group>

                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label><b>From</b> Address (भेजने वाले का पता)</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="consignor_add" 
                                            value={formData.consignor_add}
                                            />
                                        </Form.Group>

                                      
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                        <h6 className='mb-0 mt-3 bg-gray p-2'>Consignee/Move To (जहां सामान जाना है):</h6>
                                            <hr className='w-10'/>
                                        </Col>
 
                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Consignee Name (पाने वाले का नाम) <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Consignee Name.." name="consignee_name" value={formData.consignee_name} required/>
                                             {error?.consignee_name && (
                                                <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                    {error.consignee_name}
                                                </span>
                                            )}
                                        </Form.Group>
 
                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>Consignee Phone (पाने वाले का फोन) <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Consignee Phone.." name="consignee_phone" value={formData.consignee_phone} onInput={(e) => {
                                                if (e.target.value.length > 10) {
                                                    e.target.value = e.target.value.slice(0, 10);
                                                }
                                            }}/>

                                            {error?.consignee_phone && (
                                                <span className="alert alert-danger d-block mb-1 mt-1 pt-1 pb-1">
                                                    {error.consignee_phone}
                                                </span>
                                            )}
                                        </Form.Group>
 
                                        <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" xxl="4" controlId="formGridEmail" className='mt-3'>
                                            <Form.Label>GSTIN (पाने वाले का जीएसटी नंबर) <span class="text-danger"></span></Form.Label>
                                            <Form.Control type="text" onChange={handleChange} placeholder="Consignee GSTIN.." name="consignee_gst" value={formData.consignee_gst}/>
                                        </Form.Group>
 
                                            {/* TO STATE */}
                                            <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" className="mt-3">
                                                <Form.Label><b>To</b> State (पाने वाले का राज्य)</Form.Label>
                                                <Select
                                                    options={states} // Sahi
                                                    value={selectedToState}
                                                    onChange={handleToStateChange}
                                                    placeholder="Select State"
                                                />
                                            </Form.Group>
 
                                            {/* TO CITY */}
                                            <Form.Group as={Col} xs="12" sm="12" md="4" lg="4" xl="4" className="mt-3">
                                                <Form.Label><b>To</b> City (पाने वाले का शहर)</Form.Label>
                                                <Select
                                                    options={toCities} // Sahi
                                                    value={selectedToCity}
                                                    onChange={handleToCityChange}
                                                    placeholder="Select City"
                                                />
                                            </Form.Group>
                                                                               
                                        <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" controlId="exampleForm.ControlTextarea1" className='mt-3'>
                                            <Form.Label><b>To</b> Address (पाने वाले का पता)</Form.Label>
                                            <Form.Control as="textarea" rows={3} placeholder="Customer Address.." onChange={handleChange} name="consignee_add" value={formData.consignee_add}/>
                                        </Form.Group>
                                        
                                        
                                        <Col xs="12" sm="12" md="4" lg="4" xl="4" xxl="4">
                                            <h6 className='mb-0 mt-3 bg-gray p-2'>Package Details (पैकेज का विवरण):</h6>
                                            <hr className='w-10'/>
                                                <Form.Label className='mt-3'>No. Of Package (पैकेज की संख्या) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="No. Of Package.." name="no_package" value={formData.no_package}/>

                                                <fieldset className='mt-3'>
                                                    <label for="total_weight">Actual Weight (वास्तविक वजन)</label>
                                                        <div class="input-group mt-2">
                                                            <Form.Control type="number" class="form-control" placeholder="" aria-label="actual Weight" name="ac_weight" id="ac_weight" value={formData.ac_weight} onChange={handleNumberChange} onKeyDown={blockInvalidKeys} />

                                                                    <div class="input-group-append">
                                                                       <select name="ac_weight_type" class="form-main form-select" id="ac_weight_type" value={formData.ac_weight_type} onChange={handleChange}>
                                                                           <option value="KG">KG</option> 
                                                                           <option value="MT">MT</option>
                                                                           <option value="LTR">LTR</option>
                                                                           <option value="CBM">CBM</option>
                                                                           <option value="CFT">CFT</option>
                                                                           <option value="FTL">FTL</option>
                                                                           <option value="">None</option>
                                                                       </select>
                                                                </div>
                                                            </div>
                                                </fieldset>

                                                <fieldset className='mt-3'>
                                                    <label for="total_weight">Charged Weight (चार्ज किया गया वजन)</label>
                                                        <div class="input-group mt-2">
                                                            <Form.Control type="number" class="form-control" placeholder="" aria-label="Charged Weight" name="char_weight" id="char_weight" value={formData.char_weight} onChange={handleNumberChange} onKeyDown={blockInvalidKeys}/>
                                                                    <div class="input-group-append">
                                                                       <select name="charg_weight_type" class="form-main form-select" id="charg_weight_type" value={formData.charg_weight_type} onChange={handleChange}>
                                                                           <option value="KG">KG</option>
                                                                           <option value="MT">MT</option>
                                                                           <option value="LTR">LTR</option>
                                                                           <option value="CBM">CBM</option>
                                                                           <option value="CFT">CFT</option>
                                                                           <option value="FTL">CFT</option>
                                                                           <option value="">None</option>
                                                                       </select>
                                                                </div>
                                                            </div>
                                                </fieldset>

                                                <Form.Label className='mt-3'>Receive Package Condition (प्रपात माल की स्थिति) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleChange} placeholder="Receive Package Condition.." name="pack_condition" value={formData.pack_condition}/>

                                                <Form.Label className='mt-3'>Package Description (पैकेज का विवरण)</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Package Description.." onChange={handleChange} name="pack_desc" value={formData.pack_desc}/>

                                                <Form.Label className='mt-3'>Remark (अन्य विवरण)</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Remark.." onChange={handleChange} name="remark" value={formData.remark}/>
                                        </Col>

                                        <Col xs="12" sm="12" md="4" lg="4" xl="4" xxl="4">
                                            <h6 className='mb-0 mt-3 bg-gray p-2'>Package Details (पैकेज का विवरण):</h6>
                                            <hr className='w-10'/>

                                                <Form.Label className='mt-3'>Freight To Be Billed (कुल भाड़ा) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Freight To Be Billed.." name="f_to_bill" value={formData.f_to_bill}/>

                                                 <Row>
                                                    <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                    <Form.Label>Freight Paid (प्राप्त भाड़ा)<span className="text-danger"></span></Form.Label>
                                                    <Form.Control 
                                                        type="number" 
                                                        min={0} 
                                                        placeholder="Freight Paid.." 
                                                        name="f_paid" 
                                                        value={formData.f_paid || ''} // State se value connect karein
                                                        onChange={handleNumberChange} onKeyDown={blockInvalidKeys}             // onChange handler lagayein
                                                         
                                                    />
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Freight To Pay (बकाया भाड़)<span className="text-danger"></span></Form.Label>
                                                        <Form.Control 
                                                            type="number" 
                                                            min={0} 
                                                            placeholder="Freight To Pay.." 
                                                            name="f_to_pay" 
                                                            value={formData.f_to_pay || ''} // State se value connect karein
                                                            onChange={handleNumberChange} onKeyDown={blockInvalidKeys}             // onChange handler lagayein
                                                             
                                                        />
                                                     </Form.Group>
                                                    
                                                     <Form.Group>
                                                        <hr class="w-100 mb-0"></hr>
                                                     </Form.Group>
                                                        
                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Total Basic Freight <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Total Basic Freight.." name="total_basic_f" value={formData.total_basic_f}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Loading Charge <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Loading Charge.." name="loading_charge" value={formData.loading_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Unloading Charge <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Unloading Charge.." name="unloading_charge" value={formData.unloading_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>S.T Charge <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="S.T Charge.." name="st_charge" value={formData.st_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>Other Charges <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Other Charges.." name="other_charge" value={formData.other_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>LR/CN Charges <span class="text-danger"></span></Form.Label>
                                                        <Form.Control type="number" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="LR/CN Charges.." name="lrcn_charge" value={formData.lrcn_charge}/>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>GST % <span class="text-danger"></span></Form.Label>
                                                        <select name="gst_per" class="form-main form-select" value={formData.gst_per} onChange={handleChange}>
                                                            <option value="0">0</option>
                                                            <option value="5">5</option>
                                                            <option value="12">12</option>
                                                            <option value="18">18</option>
                                                            <option value="28">28</option>
                                                        </select>
                                                     </Form.Group>

                                                     <Form.Group as={Col} xs="12" sm="12" md="6" lg="6" xl="6" xxl="6" className='mt-3'>
                                                        <Form.Label>GST Paid By<span class="text-danger"></span></Form.Label>
                                                        <select name="gst_paid_by" class="form-main form-select" value={formData.gst_paid_by} onChange={handleChange}>
                                                            <option value="Consignee">Consignee</option>
                                                            <option value="Consignor">Consignor</option>
                                                            <option value="Transporter">Transporter</option>
                                                            <option value="Exempted">Exempted</option>
                                                        </select>
                                                     </Form.Group>
                                                 </Row>
                                        </Col>
                                        
                                        <Col xs="12" sm="12" md="4" lg="4" xl="4" xxl="4">
                                            <h6 className='mb-0 mt-3 bg-gray p-2'>Insurance (सामान का बीमा):</h6>
                                            <hr className='w-10'/>
                                                <Form.Group as={Col} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" className=''>
                                                        <Form.Label className='mt-3'>Material Insurance (क्या सामान का बीमा है?)<span class="text-danger"></span></Form.Label>
                                                        <select name="material_Insu" class="form-main form-select" value={formData.material_Insu} onChange={handleChange}>
                                                            <option value="Insured">Insured</option>
                                                            <option value="Not Insured">Not Insured</option>
                                                        </select>
                                                </Form.Group>

                                                <Form.Label className='mt-3'>Insurance Company (बीमा कंपनी) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleChange} placeholder="Insurance Company.." name="insu_company" value={formData.insu_company}/>

                                                <Form.Label className='mt-3'>Policy Number (बीमा पॉलिसी नंबर) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleChange} placeholder="Policy Number.." name="policy_num" value={formData.policy_num}/>

                                                <Form.Label className='mt-3'>Insurance Date (बीमा तारीख) <span class="text-danger"></span></Form.Label>
                                                    <div className="date-picker-container">
                                                            <i className='calendar-icon fa fa-calendar'></i>
                                                            <DatePicker
                                                                selected={formData.insu_date}
                                                                onChange={handleLRInsuDateChange}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Insurance Date"
                                                                className='form-control'
                                                                required
                                                            />
                                                    </div>

                                                <Form.Label className='mt-3'>Insured Amount (बीमा राशि) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} placeholder="Insured Amount.." name="insu_amount" value={formData.insu_amount}/>

                                                <Form.Label className='mt-3'>Insurance Risk (बीमा जोखिम) <span class="text-danger"></span></Form.Label>
                                                <Form.Control type="text" onChange={handleChange} placeholder="Insurance Risk.." name="insu_risk" value={formData.insu_risk}/>
                                        </Col>
                                       
                                       
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" xxl="12">
                                         <h6 className='mb-0 mt-3 bg-gray p-2'>Demurrage Charge (विलंब शुल्क):</h6>
                                            <hr className='w-10'/>
                                        </Col>

                                        <div className='form-group col-md-6 col-lg-6 col-sm-12 col-xs-12'>
                                            <fieldset className='mt-3'>
                                                    <Form.Label>Demurrage Charge (विलंब शुल्क)</Form.Label>
                                                        <div class="input-group">
                                                            <Form.Control type="number" class="form-control mt-2" placeholder="Demurrage Charge" name="demurrage_charge" onChange={handleNumberChange} onKeyDown={blockInvalidKeys} value={formData.demurrage_charge}/>
                                                                <div class="input-group-append">
                                                                    <select name="demurrage_type" class="form-main form-select" width="100px" value={formData.demurrage_type} onChange={handleChange}>
                                                                        <option value="Per Day">Per Day</option>
                                                                        <option value="Per Hour">Per Hour</option>
                                                                    </select>
                                                                </div>
                                                        </div>
                                                </fieldset>
                                        </div>
                                        
                                        <div className='form-group mt-3 col-md-6 col-lg-6 col-sm-12 col-xs-12'>
                                            <label for="total_weight">Demurrage charge applicable after (कितने समय बाद शुरू)</label>
                                            <select name="demurrage_time" class="form-main form-select mt-2" value={formData.demurrage_time} onChange={handleChange}>
                                                <option value="1 Hour">1 Hour</option>
                                                <option value="2 Hour">2 Hour</option>
                                                <option value="4 Hour">4 Hour</option>
                                                <option value="8 Hour">8 Hour</option>
                                                <option value="12 Hour">12 Hour</option>
                                                <option value="1 Day">1 Day</option>
                                                <option value="2 Day">2 Day</option>
                                                <option value="3 Day">3 Day</option>
                                                <option value="4 Day">4 Day</option>
                                                <option value="More Than 5 Day">More Than 5 Day</option>
                                            </select>
                                        </div>

                                        <div className='d-flex align-items-center submit_btn_sec'>
                                            <Button variant="primary" type="submit" className='d-flex align-items-center justify-content-center'>
                                                <span className='mx-2'>Submit</span>
                                                {loading && <span className='spin-sm'><Loader /></span>}
                                            </Button>
                                            {/* <Button variant="secondary" type="reset" onClick={resetForm} className='mx-2'>
                                                Reset
                                            </Button> */}
                                        </div>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                </Container>
            </div>
            <MobileNavigation/>
        </div>
    </>
  )
}

export default CretaeLR
